const DEFAULT_GUTTER = 8;
const DEFAULT_GAP = 4;

export const toViewportRect = (rect) => ({
  x: rect.x,
  y: rect.y,
  top: rect.top,
  right: rect.right,
  bottom: rect.bottom,
  left: rect.left,
  width: rect.width,
  height: rect.height,
});

export const isRectOutsideViewport = (
  rect,
  { viewportWidth, viewportHeight }
) => rect.bottom <= 0
  || rect.top >= viewportHeight
  || rect.right <= 0
  || rect.left >= viewportWidth;

export const getAnchoredOverlayStyle = ({
  anchorRect,
  viewportWidth,
  viewportHeight,
  preferredWidth = 250,
  preferredHeight = 240,
  align = 'start',
  gutter = DEFAULT_GUTTER,
  gap = DEFAULT_GAP,
}) => {
  const availableWidth = Math.max(0, viewportWidth - gutter * 2);
  const width = Math.min(preferredWidth, availableWidth);
  const desiredLeft = align === 'end'
    ? anchorRect.right - width
    : anchorRect.left;
  const left = Math.min(
    Math.max(desiredLeft, gutter),
    Math.max(gutter, viewportWidth - gutter - width)
  );
  const spaceBelow = viewportHeight - anchorRect.bottom;
  const spaceAbove = anchorRect.top;
  const openUpward = spaceBelow < preferredHeight && spaceAbove > spaceBelow;
  const availableHeight = Math.max(
    0,
    (openUpward ? spaceAbove : spaceBelow) - gutter - gap
  );

  return {
    position: 'fixed',
    left,
    width,
    zIndex: 9999,
    maxHeight: Math.min(preferredHeight, availableHeight),
    ...(openUpward
      ? { bottom: viewportHeight - anchorRect.top + gap }
      : { top: anchorRect.bottom + gap }),
  };
};
